import { GHLLanguageKeys as e } from "./ghl-ui.es285.js";
import o from "./ghl-ui.es839.js";
const a = {
  name: e.portugueseBrazil,
  locale: o
};
export {
  a as date_pt_BR
};
